<script setup>
defineProps({
  color: {
    type: String,
    default: 'navy', // navy, aqua(default)
  },
  title: {
    type: String,
  },
  body: {
    type: String,
  },
  trustpilotArea: {
    type: Array,
    default: null,
  },
  linkText: {
    type: String,
  },
  linkUrl: {
    type: String,
  },
  image: {
    type: String,
    default: '/images/home-hero.jpg', // image name + extension
  },
  imageAltText: {
    type: String,
    default: 'Hero Image',
  },
  imageMobile: {
    type: String,
    default: '/images/home-hero-sm.jpg', // image name + extension
  },
  imageWidth: {
    type: [Number, String],
    default: null,
  },
  imageHeight: {
    type: [Number, String],
    default: null,
  },
  imageMobileWidth: {
    type: [Number, String],
    default: null,
  },
  imageMobileHeight: {
    type: [Number, String],
    default: null,
  },
  overlap: {
    type: Boolean,
    default: true,
  },
})

const img = useImage()

const config = useRuntimeConfig()
provideTrustpilotAlwaysCookieless(Boolean(config.public.trustpilotHeroAlwaysCookieless))
</script>

<template>
  <div
    class="home-hero-block"
    :class="{ 'home-hero--navy dark-bg': color === 'navy', 'home-hero--overlap': overlap }"
  >
    <div class="container-fluid">
      <div class="home-hero__wrap">
        <div class="home-hero__image">
          <picture>
            <source
              media="(max-width: 1023px)"
              :srcset="img(imageMobile, { provider: 'fastlyAprimo', width: imageMobileWidth ?? 800, fit: 'bounds' })"
            >
            <NuxtImg
              provider="fastlyAprimo"
              :src="image"
              :alt="imageAltText"
              :width="imageWidth ?? 1440"
              fit="bounds"
              class="w-full h-auto"
            />
          </picture>
        </div>
        <div class="home-hero__body prose">
          <div class="fade-up opacity-0">
            <h1 v-if="title">
              {{ title }}
            </h1>
            <template v-if="body">
              <div v-html="body" />
            </template>
            <UButton
              v-if="linkText && linkUrl"
              class="btn no-underline w-full sm:w-62.5 justify-center"
              :to="useCmsUrl(linkUrl)"
              :locale="false"
              :color="color === 'aqua' ? 'primary' : 'info'"
              variant="solid"
              :label="linkText"
            />
            <div
              v-if="trustpilotArea"
              class="home-hero__trustpilot not-prose"
            >
              <GenericsContentArea :model="trustpilotArea" />
            </div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/home-hero-block.scss';
</style>
